import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const saveHistory = (payload) => {
  return Api(endPoints.saveHistory, payload, requestType.POST);
};
const getAllHistory = (id) => {
  return Api(`${endPoints.getAllHistory}/${id}`, requestType.GET);
};

export { saveHistory, getAllHistory };
